import { useMainStore } from '@/store'

const getCommonOptions = () => {
  const mainStore = useMainStore()
  const headers = {}
  const authInfo = mainStore.auth_info
  if (authInfo) {
    headers['access-token'] = authInfo['access-token']
    headers.client = authInfo.client
    headers.uid = authInfo.uid
  }
  return { headers }
}

const handleError = e => {
  // apiXxx() catch blocks call this AFTER an await. On SSR the active Pinia/Nuxt context can be lost
  // in the rejected-promise microtask (Nuxt 4 + Pinia 4), so useMainStore() throws
  // "Cannot read properties of undefined (reading '_s')" and masks the real API error, turning a
  // normal 401/404 into an unhandled 500. The 401 auth reset is already done inside the fetch
  // composables (store captured before the await), so guard here and never let error handling crash.
  if (!(e.response && e.response.status === 401)) return
  try {
    useMainStore().SET_STATE({ key: 'auth_info', value: null })
  } catch {
    // Active Pinia is unavailable in this async context (SSR); the 401 reset was already handled upstream.
  }
}

// force reload page if [x-app-version] header changes
const needForceReload = (path, response) => {
  // The target APIs: Get header informations API, search events API
  const isTarget = path === 'announcements/header_informations/' || /^events\//.test(path)
  // Return before touching the store: this runs after an await, and on SSR the active Pinia context
  // may be lost (Nuxt 4 + Pinia 4). It is client-only anyway (SSR returns false here).
  if (import.meta.server || !isTarget) return false

  const mainStore = useMainStore()
  const newAppVersion = response.headers && response.headers[APP_VERSION_HEADER]
  return newAppVersion && mainStore.app_version !== newAppVersion
}

const emptyPromise = () => {
  return new Promise((resolve, reject) => {
    resolve(null)
  })
}

const isDatingEventCacheUseable = () => {
  const mainStore = useMainStore()
  return mainStore.dating_event_data && mainStore.dating_event_data.cached_at + 60 * 1000 > Date.now()
}

export { getCommonOptions, handleError, needForceReload, emptyPromise, isDatingEventCacheUseable }
